import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchUserAgentSales } from 'api/agent-sales-api';
import toast from 'react-hot-toast';
import { setQuickLinks } from 'reducers/quick-links-slice';
import { getErrorString } from 'utils';

const initialState = {
  activeColumns: [],
  data: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchUserAgentSalesListing = createAsyncThunk(
  'user-agent-sales/listing',
  async ({ userId, updatedParamsObject = {} }, { dispatch }) => {
    try {
      const paramsObj = {
        'q[s]': 'created_at desc',
        ...updatedParamsObject,
      };
      const res = await fetchUserAgentSales(userId, paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const UserAgentSalesSlice = createSlice({
  name: 'user-agent-sales',
  initialState,
  reducers: {
    setUserAgentSalesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserAgentSalesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchUserAgentSalesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.data = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchUserAgentSalesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setUserAgentSalesActiveColumn } = UserAgentSalesSlice.actions;
export default UserAgentSalesSlice.reducer;
